import {
  CHANGE_SL_GROUP_TYPE,
} from './types';

export const changeSlGroupType = slGroupType => ({ type: CHANGE_SL_GROUP_TYPE, slGroupType });
